module.exports = __webpack_public_path__ + "img/2.cc41e47b.jpg";